import { Injectable, signal } from '@angular/core'
import { MaintenanceProductItem } from '../maintenance-products-tab.type'

@Injectable({ providedIn: 'root' })
export class MaintenanceProductsTabStateService {
  public readonly items = signal<MaintenanceProductItem[]>([])

  public constructor() {
    window.addEventListener('clearMaintenanceProductsVariables', () => this.reset())
  }

  public setItems(items: MaintenanceProductItem[]): void {
    this.items.set(items)
  }

  public reset(): void {
    this.items.set([])
  }
}
